import { Button as BaseButton, ButtonProps as BaseButtonProps, forwardRef } from '@chakra-ui/react';

import { useVariantStyle } from '../hooks/use-variant-style';
import { ButtonColorScheme, ButtonSize, ButtonVariant } from '../types';

type SafeButtonProps = Omit<BaseButtonProps, 'colorScheme' | 'size'>;

export interface ButtonProps extends SafeButtonProps {
	colorScheme?: ButtonColorScheme;
	size?: ButtonSize;
	variant?: ButtonVariant;
}

const Button = forwardRef(({ colorScheme = 'primary', size = 'md', variant = 'solid', ...rest }: ButtonProps, ref) => {
	const style = useVariantStyle({ colorScheme, size, variant });

	return <BaseButton ref={ref} fontFamily="ui" fontWeight="medium" lineHeight="base" {...style} {...rest} />;
});

Button.displayName = 'Button';

export { Button };
